import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=14635b8c&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=14635b8c&prod&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&id=14635b8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14635b8c",
  null
  
)

export default component.exports